import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'osc-http-403-forbidden',
  templateUrl: 'http-403-forbidden.html',
})
export class Http403ForbiddenComponent {
  public constructor(private location: Location) { }

  public goBack() {
    this.location.back();
  }
}
